var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"default-data",class:{ 'blue': _vm.hasDashboard },style:({
    'background-color': _vm.colors.primaryColor,
    'background-image': `linear-gradient(-90deg, ${_vm.colors.primaryColor} 0%, ${_vm.colors.secondColor} 50%, ${_vm.colors.primaryColor} 100%)`
  })})
}
var staticRenderFns = []

export { render, staticRenderFns }